// @flow

export const MENU_LIST_SIZE = 5
export const MENU_ITEM_HEIGHT = 35
export const INFINITY_FIRST = 100500
